import { Component, HostBinding, ChangeDetectionStrategy, Input, ViewEncapsulation } from '@angular/core';

@Component({
	selector: 'copo-loading-spinner',
	templateUrl: './loading-spinner.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.Emulated,
})
export class LoadingSpinnerComponent {
	@HostBinding('class.loading-spinner-container') @Input() container = true;
	@HostBinding('attr.role') role = 'progressbar';
	@HostBinding('attr.aria-valuemin') min = 0;
	@HostBinding('attr.aria-valuemax') max = 100;
	@Input() @HostBinding('title') title = 'Loading...';
}
